module.exports = __webpack_public_path__ + "static/media/running.4073857b.jpg";